import React from 'react';
import { AuthFlow } from '@/components/auth/AuthFlow';

const Auth = () => {
  const handleAuthComplete = () => {
    // Redirect directly to dashboard
    window.location.href = '/dashboard';
  };

  return <AuthFlow onComplete={handleAuthComplete} />;
};

export default Auth;